import CAOA1010ResponseModel from '@/api/data/CAO/CAOA1010/CAOA1010ResponseModel'
import CAOA1010RequestModel from '@/api/data/CAO/CAOA1010/CAOA1010RequestModel'

import ApiUrlConstants from '../../../common/ApiUrlConstants'
import RestService from '../../../common/RestService'

export default class CAOG1010Service {
  /**
   * CAOA1010 API呼出処理
   * @returns Object
   */
  public async callAPICAOA1010(): Promise<CAOA1010ResponseModel> {
    const caoa1010RequestModel = new CAOA1010RequestModel()
    const caoa1010ResponseModel: CAOA1010ResponseModel = <
      CAOA1010ResponseModel
    > await RestService.post(ApiUrlConstants.CAOA1010, caoa1010RequestModel)
    return caoa1010ResponseModel
  }

  /**
   * 頭文字の検索条件に従うフィルタ
   * @param dictSumInfo
   * @param searchTopWord
   * @returns faqFilterdictLst
   */
  public filterByInitial(dictSumInfo: any, searchTopWord: string) {
    let faqFilterdictLst = []

    if (searchTopWord && dictSumInfo) {
      faqFilterdictLst = dictSumInfo[searchTopWord] ?? []
    }
    faqFilterdictLst.forEach((item) => {
      item.dictTitle = item.dictTitle
        ?.replaceAll('&quot;', '"')
        .replaceAll('&comma;', ',')
      item.dictCont = item.dictCont
        ?.replaceAll('&quot;', '"')
        .replaceAll('&comma;', ',')
    })

    return faqFilterdictLst
  }
}
